import { Auth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { Card } from '@/components/shared/card';
import { Alert, AlertDescription } from "@/components/shared/alert";
import { AuthError, AuthApiError } from '@supabase/supabase-js';
import MainLayout from '@/components/layout/MainLayout';

const Login = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange(async (event, session) => {
      if (event === 'SIGNED_IN') {
        navigate('/assessment');
      }
      if (event === 'USER_UPDATED') {
        const { error } = await supabase.auth.getSession();
        if (error) {
          handleAuthError(error);
        }
      }
      if (event === 'SIGNED_OUT') {
        setError(null);
      }
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  const handleAuthError = (error: AuthError) => {
    console.error('Auth error:', error);
    if (error instanceof AuthApiError) {
      switch (error.code) {
        case 'email_provider_disabled':
          setError('Email login is currently disabled. Please contact the administrator.');
          break;
        case 'invalid_credentials':
          setError('Invalid email or password. Please check your credentials and try again.');
          break;
        case 'user_not_found':
          setError('No user found with these credentials.');
          break;
        default:
          setError(error.message);
      }
    } else {
      setError(error.message);
    }
  };

  return (
    <MainLayout>
      <div className="flex-1 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-background">
        <div className="w-full max-w-md space-y-8">
          <div className="text-center">
            <h2 className="mt-6 text-3xl font-bold tracking-tight text-foreground">
              Welcome Back
            </h2>
            <p className="mt-2 text-sm text-muted-foreground">
              Sign in to your account to save and track your assessments
            </p>
          </div>
          <Card className="mt-8 p-6 bg-card">
            {error && (
              <Alert variant="destructive" className="mb-6">
                <AlertDescription>{error}</AlertDescription>
              </Alert>
            )}
            <Auth
              supabaseClient={supabase}
              appearance={{ 
                theme: ThemeSupa,
                style: {
                  button: {
                    background: 'var(--primary)',
                    color: 'var(--primary-foreground)',
                    borderRadius: '6px',
                    fontWeight: '500'
                  },
                  anchor: {
                    color: 'var(--primary)'
                  }
                }
              }}
              theme="light"
              providers={[]}
            />
          </Card>
        </div>
      </div>
    </MainLayout>
  );
};

export default Login;